// extracted by mini-css-extract-plugin
module.exports = {"icon":"_ec7d34f","balance":"_22a225b","userId":"_49339f9","decimal":"_0dee235","account":"_306d2f1","deposit":"_9ea5b5e","summaryWrapper":"_849cf84","summaryIcon":"_b09d5f9"};